<!-- Add penalty form -->
<div class="add-edit-penality-modal" *ngIf="iEditShipForm">
    <snl-modal [type]="'medium'" [open]="iEditShipForm" [settings]="setting">
      <div slot="heading">Modify Pool Points</div>
      <div slot="headingDescription">
        <span class="text d-flex">
          <span class="d-flex container-c-bx col-gap-8">
            Ship : 
            <span class="ShipsPillsMain fw-700 CommonPillsMain color__primary d-flex"> 
              <span class="truncate-txt single-line ship-name"> {{shipDetail.vslName}}</span>
              <span class="ShipNumberPills CommonPills fw-400 labels d-flex align-items-center">{{shipDetail.vslNumber}} </span>
            </span>
          </span>
         </span>
      </div>
      <div slot="modalContent">
        <form [formGroup]="editShipForm">
          <div class="d-flex filed-section">
            <div class="half-containers form-field">
              <snl-input class="disabled" placeholder="Sub Pool" label="Sub Pool" formControlName="subPool" [value]="editShipForm.value.subPool"></snl-input>
            </div>
            <div class="half-containers form-field">
              <snl-input class="disabled" placeholder="Ship Owner" label="Ship Owner" formControlName="owners" [value]="editShipForm.value.owners"></snl-input>
            </div>
          </div>
          <div class="modified-pool-point flex-column">
              <div class="body-b2">Active Pool Points</div>
              <div class="pool-section flex-column align-items-start col-gap-8 half-containers">
                <span class="poolpoint"> {{shipDetail.poolPoint | number : '1.2-2'}}</span>
                <span class="caption" *ngIf="shipDetail.poolPointEffectiveFrom">wef. {{shipDetail.poolPointEffectiveFrom | date:'d MMM y'}}</span>
              </div>
          </div>
          <div class="d-flex effectiveDiv">
            <div class="effectiveDate half-containers">
              <snl-input placeholder="" label="New Pool Points" formControlName="newPoolPoint" [isError]="((editShipForm.controls['newPoolPoint'].hasError('required')|| editShipForm.controls['newPoolPoint'].hasError('pattern')) && viewModel.submit)"></snl-input>
            </div>
            <div class="half-containers">
              <snl-input snlDatePicker [min]="viewModel.minDate" class="datepicker" placeholder="" label="Effective Date" formControlName="effectiveFormDate" [isError]="(editShipForm.controls['effectiveFormDate'].hasError('required') && viewModel.submit)" (selectedDate) = "selectedDate($event)" [isTrailingIconDisplayed]="true" trailingIcon="fa-calendar far"></snl-input>
            </div>
          </div>
        </form>
      </div>
      <div slot="modalFooter">
        <snl-button size="small" (buttonClick)="submitShip()">Save</snl-button>
        <snl-button size="small" type="secondary" (buttonClick)="closePopup()">Cancel</snl-button>
      </div>
    </snl-modal>
  </div>
  